import React from 'react'
import { connect } from 'react-redux'
import Navigation from 'support/navigation'
import AlertModalView from 'support/popup_dialogs/views/components/alert_modal_view/AlertModalView'
import { hideDialog } from 'support/popup_dialogs/modal_alert_controller/ModalActions'
import { showPopupDialog } from 'support/popup_dialogs'
import i18n from 'support/i18n'

import ErrorSubmitModal from './ErrorSubmitContainer'
import SuccessSubmitModal from './SucessSubmitContainer'

import {
  postInnovateIdeaApprove,
  getIdeaInnovateDetail,
} from 'services/innovate/idea'

const mapStateToProps = () => ({
  title: i18n.t('CONFIRMATION_MESSAGE'),
  description:
    'Are you certain you want to approve or change the status of this idea?',
  mainButtonText: i18n.t('ACCEPT'),
  cancelable: true,
  cancelButtonText: i18n.t('CANCEL'),
})

const mapDispatchToProps = (dispatch, ownProps) => {
  const { ideaIdKey: id, closeApproveDialog } = ownProps.ideaApproveParams

  
  return {
    mainButtonAction: () => {
      const onSuccess = response => {
        // Refresh current idea details
        dispatch(getIdeaInnovateDetail(id))

        // Close confirmation popup after success
        dispatch(hideDialog())
        
        if (typeof closeApproveDialog === 'function') {
          closeApproveDialog()
        }
        // Optional success message
        showPopupDialog(
          <SuccessSubmitModal
            description="Your idea has been successfully approved and the status has been updated."
          />,
          dispatch
        )

      }

      const onFailure = ({ data }) => {
        // Close confirmation popup
        dispatch(hideDialog())
        
        // if (typeof closeApproveDialog === 'function') {
        //   closeApproveDialog()
        // }

        const messageTag =
          data && data.error
            ? `${data.error.desc}`
            : 'BACKEND_ERRORS.UNEXPECTED'

        showPopupDialog(
          <ErrorSubmitModal description={messageTag} />,
          dispatch
        )
      }

      dispatch(
        postInnovateIdeaApprove(
          ownProps.ideaApproveParams,
          onSuccess,
          onFailure
        )
      )
    },

    cancelButtonAction: () => dispatch(hideDialog()),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AlertModalView)